import { Article } from '../types';

// Keep cache writes well under the ~5 MB localStorage quota and avoid
// stuttering on mobile.
export const MAX_CACHED_ARTICLES = 200;

// Persist articles to localStorage with a quota guard. Drops the heaviest
// decorative fields and trims to MAX_CACHED_ARTICLES, then halves the slice
// on QuotaExceededError until the write succeeds.
export const cacheArticles = (articles: Article[]): void => {
  const slim = articles
    .slice(0, MAX_CACHED_ARTICLES)
    .map((a) => {
      const { clickbaitExplanation: _exp, autoFilledExcerpt: _auto, ...rest } = a;
      return rest;
    });

  const writeWithFallback = (slice: Article[]): void => {
    try {
      localStorage.setItem('cached_articles', JSON.stringify(slice));
      localStorage.setItem('cached_articles_time', Date.now().toString());
      localStorage.setItem('cached_articles_date', new Date().toDateString());
    } catch {
      if (slice.length > 50) {
        writeWithFallback(slice.slice(0, Math.floor(slice.length / 2)));
      }
    }
  };
  writeWithFallback(slim);
};

export const restoreCachedArticles = (): Article[] => {
  try {
    const raw = localStorage.getItem('cached_articles');
    if (!raw) return [];
    const parsed = JSON.parse(raw) as Array<Article & { pubDate: string }>;
    return parsed.map((a) => ({ ...a, pubDate: new Date(a.pubDate) }));
  } catch {
    return [];
  }
};
